<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15LjGtK/tc-custom/9781402790997.jpg?1712387812872" alt="This image is the cover for the book Physics Book, Union Square & Co. Milestones"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Physics Book, Union Square & Co. Milestones
      </h1>
      <p class="bookDescription body article font2">
        <b>“A thrilling, fast-paced excursion through the history of physical discovery . . . from silly putty to string theory” (Dr. Paul Halpern, author of <i>Collider</i>).</b><br/><br/>Following his previous volumes, <i>The Science Book</i> and <i>The Math Book</i>, acclaimed science writer Clifford Pickover returns with a richly illustrated chronology of physics, containing 250 short, entertaining, and thought-provoking entries. In addition to exploring such engaging topics as dark energy, parallel universes, the Doppler effect, the God particle, and Maxwells demon, <i>The Physics Book</i> extends back billions of years to the hypothetical Big Bang and forward trillions of years to a time of “quantum resurrection.” Like the previous titles in this series, <i>The Physics Book</i> offers a lively and accessible account of major concepts without getting bogged down in complex details.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Clifford A. Pickover
      </h2>
      
      <p class="authorDescription body article">Clifford A. Pickover, a research staff member at IBM&rsquo;s T. J. Watson Research Center, is an authority on the interface of science, art, mathematics, computing, and the visual modeling of data. He is the author of such highly regarded books as <I>Black Holes: A Traveler&rsquo;s Guide</I>, <I>The Alien IQ Test</I>, and <I>Chaos in Wonderland: Visual Adventures in a Fractal World</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Sterling Publishing Co., Inc
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e36b519c